import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "uc_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY)),
};

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        const { data } = await axios.post(`${BACKEND}/api/auth/refresh`, {}, { withCredentials: true });
        tokenStore.set(data.access_token);
        return api(cfg);
      } catch {
        tokenStore.set(null);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function uploadFile(file, imageOnly = false) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(imageOnly ? "/upload?image=true" : "/upload", fd);
  return data;
}

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);
